/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useLayoutEffect, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { useNavigate, useLocation } from 'react-router-dom';
import { useParams } from 'react-router';
import useSnackbar from 'src/hooks/useCustomSnackbar';
// @mui
import {
    Card,
    Typography,
    Dialog,
    Box,
    Switch,
    Paper,
    Button,
    Popper,
    TablePagination,
    MenuList,
    MenuItem,
    Grow,
    DialogTitle,
    DialogActions,
    Tooltip,
    FormControl,
    Select,
    InputLabel,
    ClickAwayListener,
    useTheme,
    TextField,
    InputAdornment,
    LinearProgress,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { alpha } from '@mui/material/styles';
// components
import { widgetArrayTask } from 'src/constants/widgetConstants';
import { DASHBOARD_WIDGET_COUNTER } from 'src/constants/newLead';
import MultiAssigneesDropdown from 'src/components/Dropdowns/SelectMultiAssignees';
import TaskReportWidget from 'src/components/reportsWidget/TaskReportWidget';
import { treatmentBoxStyle } from 'src/styles/NewLead';
import { useForm } from 'react-hook-form';
import { FormProvider } from 'src/components/hook-form';
import useWindowSize from 'src/hooks/windowSizeListner';
import { initializeFacebookAuthToken } from 'src/redux/slices/whatsapp';
import { getJourneyLabel, getJourneyDot } from 'src/utils/leadJourney';
import Activities from './Activities';
import { FollowUp, AppointmentPage } from '../lead';
import { ReusableSidebar } from '../calendar';
import { Iconify, Label } from '../../../components';
import { NotFound } from '../../../components/empty-content';
import { UnableToContact } from '../../../components/failedToAttendTabs';
import { AssignTaskPopup, AddReminderPopup, EditPersonalDetailsPopup, AppointmentAssignTaskPopup, ArchivedLeadPopUp, AddNotePopup } from '../../../components/dialogPopUp';
// custom-avatar
import {
    OpenAttendedPopup,
    OpenUnAttendedPopup,
    OpenConsultationPopup,
    OpenContactLeadPopup
} from '../../../components/fullScreenPopUps';
import LeadTemplate from '../../../pages/dashboard/LeadTemplate';
// general
import {
    AttendedAppointment,
    MessageAndReminder,
    PaymentOption,
    PersonalDetails,
    TreatmentAndAppointment
} from '../general/app';
// redux
import { setCurrentTreatmentDataGlobal } from '../../../redux/slices/multiTreatment';
import {
    getLeadReminderData,
    followUpSlice,
    getAppointment,
    tableLead,
    clearLead,
    updateSteps,
    updateLeadDetail,
    ConsultationAttended,
    RecordAttended,
    recordUnAttended,
    getNewLead,
    updateFollowUpLead,
    CompleteTreatment,
    updateReminder,
    addTaskTableData,
    getLeadNotes,
    getLeadNotesWithFilter,
    setAssigned,
    addLeadTaskTab,
    leadTaskListCounter,
    updateTaskCounter,
    updateSeparateTaskCounter,
    updateLeadTaskCounter,
    setLeadDetailTaskPageFilter,
    getReminderData,
    deleteReminderData,
    taskCompletedUser,
    setAction,
    taskUnassignedUser,
    ArchivedLeadDashBoard,
    loadMoreTasksPageData,
    loadMoreTasksLaneData,
    loadDashboardScheduledTasks
} from '../../../redux/slices/lead';
import { getPracticeItem } from '../../../redux/slices/practice';
import { clearPracticeUserData } from '../../../redux/slices/practiceUser';
import { getActivities } from '../../../redux/slices/activity';
import { useSelector, dispatch } from '../../../redux/store';
import { updatePracticeId } from '../../../redux/slices/practiceTreatmentList';
import { setLoader } from '../../../redux/slices/loader';
import { getWhatsaAppThreads, resetWhatsappChat } from '../../../redux/slices/whatsappV2';
// constants
import { CreateLeadHeaderData, TASK_TYPE_HEAD, LEAD_STATUS_HEAD } from '../../../constants/LeadDetailConst';
// hooks
import {
    useTable,
    useTabs,
    useResponsive,
    useRecordAttendToggle,
    useUnRecordAttendToggle,
    useReminderToggle,
    useArchivedToggle,
    useAssignTaskToggle,
    useToggle,
    useAuth,
    useConsultationAttendToggle,
    useSwitchUserToggle,
    useReloadWidgetCounter
} from '../../../hooks';
// utils
import { getIconAndColor, getPriorityColor } from '../../../utils/taskPriority';
import capitalizeFirstLetter from '../../../utils/capitalizedFunc';
import { isDentallySyncTask } from '../../../utils/getTasksData';
import { setRowLeadData } from '../../../utils/getRowLeadData';
import { localStorageRemoveItem } from '../../../utils/storage-available';
// style
import { common, primary } from '../../../theme/palette';
import {
    taskCard,
    taskButton,
    plusMenu,
    plusButton,
    plusMenuIcon,
    completeTreatmentCancel,
    completeTreatmentConfirm,
    taskListCardStyle,
    taskButtonForWhatsapp
} from '../../../styles/leadTaskReminder';
import { yesBtnStyleForLoader } from '../../../styles/Common';

import WaPopupChat from '../../whatsapp/WaPopupChat';

const TaskReminder = ({ type, reminder, leadDetail, reloadTaskCounter, handleLoading, reset, selectedDateRange, isDashboard, shouldRunTaskEffect, onV2TaskClick }) => {


    const navigate = useNavigate();
    const theme = useTheme();
    const leadId = useParams();
    const inputRef = useRef();
    const personalDetailPopupRef = useRef();
    const reminderDataId = useRef();
    const isLight = theme.palette.mode === 'light';
    const { user } = useAuth();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const isDesktop = useResponsive('down', 'sm');
    const { state } = useLocation();

    const { practiceUser } = useSelector((state) => state.practiceUser);
    const { activityList } = useSelector((state) => state.activity);
    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    const { threadMessages, currentBusinessId } = useSelector((state) => state.whatsappV2);
    const [anchorElAssign, setAnchorElAssign] = useState(null);
    const {
        isAppointmentBooked, attendance,
        contactLead, BookingAttendance,
        markAsComplete, followUpLead,
        isAssigned, leadTaskTab,
        taskTableData: {
            limit,
            offset,
            filter,
            assignUser,
            tasks: {
                limit: taskLimit,
                offset: taskOffset,
                filter: taskFilter,
                assignUser: taskAssingUser,
            }
        },
        taskCounter, taskLeadCounter, separateTaskCounter,
        dashContact: {
            pageNumber,
            perPage,
            order,
            orderValue,
            search,
            treatment,
            date,
            status: updateStatus,
            filterTags,
        },
        dashboardTaskPageFilter,
        leadDetailTaskPageFilter,
        taskPageFilter,
        taskDetail,
        isTasksCompleted,
        action,
        unassignedUser,
        taskLaneCounts,
        isLoadingFinish,
    } = useSelector((state) => state.lead);

    const { isLoader } = useSelector((state) => state.loaderReducer);

    const startDate = date ? date[0]?.startDate : null;
    const endDate = date ? date[0]?.endDate : null;

    const { currentTab, onChangeTab, setCurrentTab } = useTabs(type === 'LeadDetail' ? leadTaskTab : type === 'Tasks' ? taskFilter : filter);

    const location = useLocation();
    const routeData = new URLSearchParams(location.search);
    const searchPractice = routeData.get('practiceId');
    const taskId = routeData.get('taskId');
    const [validStep, setValidStep] = useState(false);
    const [assignedUser, setAssignedUser] = useState(isAssigned);
    const [tasksCompletedUser, setTasksCompletedUser] = useState(isTasksCompleted);
    const [Lead, setLead] = useState(0);
    const [userID, setUserID] = useState('');
    const [open, setOpen] = useState(false);
    const [markComplete, setMarkComplete] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [anchorEl] = useState(null);
    const [reminderList, setReminderList] = useState([]);
    const [addPopupType, setAddPopupType] = useState('editTask');
    const [leadData, setLeadData] = useState('');
    const [assigneeData] = useState([]);
    const [reminderData, setReminderID] = useState(0);
    const [openSidebar, setOpenSidebar] = useState(false);
    const [additionalTabState, setAdditionalTabState] = useState('Today');
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [deleteData, setDeleteData] = useState(null);
    const [assignees, setAssignees] = useState([]);
    const leadTreatment = leadDetail?.lead_treatments[0];
    const addTaskHide = type === 'LeadDetail' ? leadTreatment?.status !== undefined && leadTreatment?.status !== 'CLOSED' : type === 'dashboard' || type === 'Tasks';
    const { onChangeTab: onAdditionalTab } = useTabs(additionalTabState);
    const { currentTreatmentDataGlobal } = useSelector((state) => state.multiTreatment);
    const [options] = useState('');
    const [templateOpen, setTemplateOpen] = useState('');
    const [selectedValue, setSelectedValue] = useState('');
    const [selectedAssigneeFilter, setSelectedAssigneeFilter] = useState([]);
    const [taskWidgetTreatmentValue, setTaskWidgetTreatmentValue] = useState(null);
    const [reloadCounters, setReloadCounters] = useState(null);
    const [openContactWhatsapp, setOpenContactWhatsapp] = useState({ open: false });
    const [waPopup, setWaPopup] = useState({ open: false, lead: null });
    const [waLoading, setWaLoading] = useState(false);
    const [leadStatusFilter, setLeadStatusFilter] = useState('');
    const [taskSearch, setTaskSearch] = useState('');
    const searchTimeoutRef = useRef(null);
    const [width, height] = useWindowSize();

    const { reloadWidgetCounter } = useReloadWidgetCounter();

    useEffect(() => {
        if (type === 'Tasks' ? Boolean(taskAssingUser) : Boolean(assignUser)) {
            setSelectedValue('My tasks');
        } else if (unassignedUser) {
            setSelectedValue('Unassigned tasks');
        } else {
            setSelectedValue('All');
        }

    }, [taskAssingUser, unassignedUser, assignUser, taskWidgetTreatmentValue]);

    const assigneeDataFilter = [];
    selectedAssigneeFilter.forEach(els => assigneeDataFilter.push(els.id));

    const hasTaskFilterMounted = useRef(false);

    useEffect(() => {
        // Skip the initial mount to prevent clearing dashboard widgets when the component first renders
        if (!hasTaskFilterMounted.current) {
            hasTaskFilterMounted.current = true;
            return;
        }
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : taskAssingUser || '';
        const taskFilter = { assigneeUser: assignees, isTasksCompleted, unassignedUser, filter: currentTab }
        reloadWidgetCounter({ array: widgetArrayTask, taskFilter });

    }, [selectedAssigneeFilter, assignedUser, isTasksCompleted, unassignedUser, taskAssingUser, markComplete])

    useEffect(() => {
        if (reloadCounters) {
            sidebarCloser();
            const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : taskAssingUser || '';

            if (type === "Tasks") {
                const taskFilter = { assigneeUser: assignees, isTasksCompleted, unassignedUser, filter: currentTab }
                reloadWidgetCounter({ array: widgetArrayTask, taskFilter });
            }

            // Also reload dashboard widget counters when type is dashboard
            if (type === 'dashboard' || isDashboard) {
                reloadWidgetCounter({ array: DASHBOARD_WIDGET_COUNTER });
            }

            // Re-fetch the actual task list so lanes update after status changes.
            // For the dashboard, chain the scheduled fetch after the main fetch completes
            // so getAllReminderData (replace) always lands before appendDashboardScheduledData (append).
            (async () => {
                await dispatch(getLeadReminderData(practiceId, type, rowsPerPage, rowsPerPage * page, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', assignees, '', '', '', additionalTabState, isTasksCompleted, false, selectedDateRange, unassignedUser, taskWidgetTreatmentValue));
                if ((type === 'dashboard' || type === 'Tasks') && practiceId) {
                    await dispatch(loadDashboardScheduledTasks(practiceId, currentTab === 'All' ? '' : currentTab, assignees, tasksCompletedUser, unassignedUser, taskWidgetTreatmentValue, type === 'Tasks', taskSearch));
                }
            })();

            // Only reload tab counters when NOT on the TasksPage — TasksPage already
            // calls reloadTaskCounter() on mount and filter changes, so calling it
            // here too doubled the 9-call loop (Sentry: REACT-47, 11 users, 3276 events).
            if (type !== 'Tasks') {
                reloadTaskCounter({ userId: assignees, id: type === 'LeadDetail' ? leadId.id : '', additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser, treatment: taskWidgetTreatmentValue });
            }

            // Reset reloadCounters so next update triggers the effect
            setReloadCounters(false);
        }

    }, [reloadCounters])

    useEffect(() => {
        if (selectedAssigneeFilter && selectedAssigneeFilter.length > 0) {
            setSelectedValue('All');
        }
    }, [selectedAssigneeFilter]);

    const [rowLead, setRowLead] = useState({
        lead_id: '',
        treatment_id: '',
        price: '',
        first_name: '',
        last_name: '',
        status: '',
        treatment_name: '',
        created_at_human: '',
        lead_treatments__lead_contacted_counts__count: 0
    });

    const {
        page,
        rowsPerPage,
        onChangePage,
        onChangeRowsPerPage,
        setPage,
        setRowsPerPage
    } = useTable();


    const defaultValues = {
        multiSelectAssignee: assigneeDataFilter || [],
    };
    const methods = useForm({
        defaultValues
    });
    const { setValue, handleSubmit } = methods;

    const onSubmit = (data) => {
        setValidStep(!!data);
    };

    useEffect(() => {
        if (practiceId) {
            dispatch(getPracticeItem(practiceId));
        }
    }, [practiceId]);

    useEffect(() => {
        if (filter && type !== 'LeadDetail' && type !== 'Tasks') {
            handleFilterTask('', filter);
        }
    }, [filter]);

    useEffect(() => {
        if (!isEmpty(reminderList) && state?.openSideBar) {
            const data = reminderList?.find((ele) => ele.id === state?.taskId);
            if (!isEmpty(data)) {
                sidebarHandler(data);
            }
        }
    }, [state, reminderList]);

    const handleClose = (status, archive) => {
        dispatch(setLoader(false));
        setOpenSidebar(false);
        if (type === 'LeadDetail' && archive === true) {
            navigate('/dashboard/app');
        };
        if (status?.toLowerCase?.() === 'finish') {
            const data = {
                is_completed: true
            };
            dispatch(updateReminder(data, reminderDataId.current, practiceId, handleReminder, 'markComplete'));
            setConfirmation(false);
        };
        setTimeout(() => {
            const htmlElement = document.querySelector('body');
            htmlElement.classList.remove('overflow-hidden');
        }, 200);
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
        dispatch(updateSteps(null));
        dispatch(updateFollowUpLead(null));
        onCloseConsultationAttend();
        onCloseRecordAttend();
        onCloseUnRecordAttend();
        onCloseContacts();
        setOpenContactWhatsapp({ open: false });
        onCloseReminder();
        setLead(null);
    };

    const STEPS = [
        {
            label: 'Contact',
            component: <FollowUp ref={inputRef} handleNext={onSubmit} handleClose={handleClose} />
        }
    ];

    const [leadStep, setLeadStep] = useState(STEPS);

    useEffect(() => {
        if (!isEmpty(currentTreatmentDataGlobal)) {
            dispatch(setCurrentTreatmentDataGlobal(null));
        }
        if (action) {
            dispatch(setAction(null));
        }
    }, []);

    useEffect(() => {
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        if (isDashboard && shouldRunTaskEffect?.current) {
            reloadTaskCounter({ userId: assignees, id: type === 'LeadDetail' ? leadId.id : '', additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser, treatment: taskWidgetTreatmentValue });
        }
    }, [selectedDateRange]);

    useEffect(() => {
        if (type) {
            switch (type) {
                case 'dashboard':
                    setAdditionalTabState(dashboardTaskPageFilter);
                    break;
                case 'LeadDetail':
                    setAdditionalTabState(leadDetailTaskPageFilter);
                    break;
                case 'Tasks':
                    setAdditionalTabState(taskPageFilter);
                    break;
                default:
                    setAdditionalTabState('');
                    break;
            }
        }
    }, [type]);

    useEffect(() => () => cleanUp(), []);

    useEffect(() => {
        if (reset) {
            setCurrentTab('');
            dispatch(setLeadDetailTaskPageFilter('Today'));
            onAdditionalTab('', 'Today');
            setAdditionalTabState('Today');
            dispatch(taskCompletedUser(false));
            dispatch(taskUnassignedUser(false));
            dispatch(setAssigned(false));
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, '', leadDetail.id, '', '', '', '', additionalTabState));
            setPage(0);
            setRowsPerPage(10);
        }
    }, [reset]);

    useLayoutEffect(() => {
        if (!reminder) {
            setReminderList([]);
        }
        if (reminder && reminder?.results) {
            setReminderList(reminder?.results);
        }
    }, [reminder]);

    useEffect(() => {
        if (taskDetail) {
            setLeadData(taskDetail);
        }
    }, [taskDetail]);

    useEffect(() => {
        if (searchPractice && taskId) {
            dispatch(updatePracticeId(searchPractice));
            dispatch(getReminderData(searchPractice, taskId));
            setOpenSidebar(true);
        }
    }, [searchPractice, taskId]);

    useEffect(() => {
        if (leadData && leadData?.lead?.id) {
            dispatch(getLeadNotes(leadData?.lead?.id, practiceId));
        }
    }, [leadData]);

    useEffect(() => {
        if (isAssigned || !isAssigned) {
            setAssignedUser(isAssigned);
        }
    }, [isAssigned]);

    useEffect(() => {
        if (isTasksCompleted || !isTasksCompleted) {
            setTasksCompletedUser(isTasksCompleted);
        }
    }, [isTasksCompleted]);

    // Load WhatsApp threads if WhatsApp is initialized but threads aren't loaded yet
    useEffect(() => {
        if (currentBusinessId && currentBusinessId !== -1 && (!threadMessages || threadMessages.length === 0)) {
            setWaLoading(true);
            dispatch(getWhatsaAppThreads());
        }
    }, [currentBusinessId]);

    // Stop WhatsApp loading once threads arrive
    useEffect(() => {
        if (threadMessages && threadMessages.length > 0) setWaLoading(false);
    }, [threadMessages]);

    // Fallback: stop loading after 5s even if no messages exist
    useEffect(() => {
        if (waLoading) {
            const timer = setTimeout(() => setWaLoading(false), 5000);
            return () => clearTimeout(timer);
        }
        return undefined;
    }, [waLoading]);

    // Build a lookup: leadId → last WhatsApp message for quick access in task cards
    const whatsappByLeadId = useMemo(() => {
        if (!threadMessages || !threadMessages.length) return {};
        const map = {};
        threadMessages.forEach((contact) => {
            const leadId = contact?.lead?.id;
            if (leadId && contact?.last_message) {
                const isReceived = contact?.last_message?.from_waid === contact?.to_waid;
                map[leadId] = {
                    body: contact.last_message.body || '',
                    isReceived,
                    unreadCount: contact?.is_read ? 0 : (contact?.unread_count ?? 0),
                    time: contact.last_message.updated_at_human || '',
                    _thread: contact,
                    _phoneNumber: contact?.to_waid || '',
                };
            }
        });
        return map;
    }, [threadMessages]);

    const cleanUp = () => {
        if (type === 'LeadDetail') {
            addTableData(10, 0, '', '');

        }
        if (type === 'dashboard') {
            setReminderList([]);
        }
    };

    const addTableData = (tableLimit, tableOffset, tableFilter, tableAssignUser) => {
        const data = type === 'Tasks' ? {
            limit,
            offset,
            filter,
            assignUser,
            tasks: {
                limit: tableLimit,
                offset: tableOffset,
                filter: tableFilter,
                assignUser: tableAssignUser
            },
        } : {
            limit: tableLimit,
            offset: tableOffset,
            filter: tableFilter,
            assignUser: tableAssignUser,
            tasks: {
                limit: taskLimit,
                offset: taskOffset,
                filter: taskFilter,
                assignUser: taskAssingUser
            },
        };
        dispatch(addTaskTableData(data));
    };

    const handleChangePage = (event, newPage) => {
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        dispatch(getLeadReminderData(practiceId, type, rowsPerPage, rowsPerPage * newPage, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', assignees, '', '', '', additionalTabState, isTasksCompleted, false, selectedDateRange, unassignedUser, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
        onChangePage(event, newPage);
        addTableData(rowsPerPage, rowsPerPage * newPage, currentTab === 'All' ? '' : currentTab, assignees);
    };

    const handleChangePerPage = (event) => {
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        dispatch(getLeadReminderData(practiceId, type, event.target.value, 0, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', assignees, '', '', '', additionalTabState, isTasksCompleted, false, selectedDateRange, unassignedUser, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
        onChangeRowsPerPage(event);
        addTableData(event.target.value, 0, currentTab === 'All' ? '' : currentTab, assignees);
    };

    const handleFilterTask = (event, newValue) => {
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        dispatch(getLeadReminderData(practiceId, type, 10, 0, newValue === 'All' ? '' : newValue, type === 'LeadDetail' ? leadId.id : '', assignees, '', '', '', additionalTabState, isTasksCompleted, false, selectedDateRange, unassignedUser, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
        onChangeTab(event, newValue);
        onChangeRowsPerPage({ target: { value: 10 } });
        addTableData(10, 0, newValue === 'All' ? '' : newValue, assignees);
        if (type === 'LeadDetail') {
            dispatch(addLeadTaskTab(newValue));
        }
        reloadTaskCounter({ userId: assignees, id: type === 'LeadDetail' ? leadId.id : '', additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser, treatment: taskWidgetTreatmentValue });
    };

    const handleLeadStatusFilter = (event) => {
        const newStatus = event.target.value;
        setLeadStatusFilter(newStatus);
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        dispatch(getLeadReminderData(practiceId, type, 10, 0, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', assignees, '', '', '', additionalTabState, isTasksCompleted, false, selectedDateRange, unassignedUser, taskWidgetTreatmentValue, newStatus, taskSearch));
        onChangeRowsPerPage({ target: { value: 10 } });
        addTableData(10, 0, currentTab === 'All' ? '' : currentTab, assignees);
    };

    const handleTaskSearchChange = (event) => {
        const newSearch = event.target.value;
        setTaskSearch(newSearch);
        if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = setTimeout(async () => {
            const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
            await dispatch(getLeadReminderData(practiceId, type, 10, 0, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', assignees, '', '', '', additionalTabState, isTasksCompleted, false, selectedDateRange, unassignedUser, taskWidgetTreatmentValue, leadStatusFilter, newSearch));
            if ((type === 'dashboard' || type === 'Tasks') && practiceId) {
                await dispatch(loadDashboardScheduledTasks(practiceId, currentTab === 'All' ? '' : currentTab, assignees, tasksCompletedUser, unassignedUser, taskWidgetTreatmentValue, type === 'Tasks', newSearch));
            }
            onChangeRowsPerPage({ target: { value: 10 } });
            addTableData(10, 0, currentTab === 'All' ? '' : currentTab, assignees);
        }, 400);
    };

    const handleAttendFailedClick = (id, reminder, lead) => {
        localStorageRemoveItem('localTreatmentData');
        if (reminder?.id && reminder?.lead_treatment?.lead?.id) {
            setRowLead(setRowLeadData(reminder, leadData));
        }
        if (id && reminder) {
            leadDataHandler(reminder);
            dispatch(followUpSlice(id, practiceId));
            setTimeout(() => {
                dispatch(getAppointment(practiceId, id));
            }, 300);
        }
        else {
            dispatch(followUpSlice(lead || Lead, practiceId));
            setTimeout(() => {
                dispatch(getAppointment(practiceId, lead || Lead));
            }, 300);
        }
        dispatch(updateFollowUpLead('UnAttended'));
        setTimeout(() => {
            onOpenUnRecordAttend();
        }, 800);
    };

    const handleReminderPopup = (notes, data) => {
        if (type === 'LeadDetail') {
            setLead(leadDetail?.id);
        }
        if (data) {
            setLeadData(data);
        }
        setAddPopupType(notes);
        onOpenReminder();
    };

    const handleAttendClick = (lead, data) => {
        leadDataHandler(data.id);
        dispatch(updateFollowUpLead('Attended'));
        dispatch(followUpSlice((lead || Lead), practiceId));
        dispatch(setCurrentTreatmentDataGlobal({
            lead_id: leadDetail?.id || '',
            first_name: leadDetail?.first_name || '',
            last_name: leadDetail?.last_name || '',
            treatmentData: data?.lead_treatment
        }));
        setTimeout(() => {
            dispatch(getAppointment(practiceId, (lead || Lead)));
            onOpenRecordAttend(lead || Lead);
        }, 800);
    };

    const buttonHandleClose = (event) => {
        if (anchorEl.current && anchorEl.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    useEffect(() => {
        if (practiceUser && practiceUser.results) {
            const userData = practiceUser?.results.filter((el) => el?.user?.id === user?.pk);
            if (userData.length > 0) {
                setUserID(userData[0]?.user?.id);
            }
        }
    }, [practiceUser]);

    useEffect(() => {
        if (contactLead) {
            const STEPS = [
                {
                    label: 'Contact',
                    component: <FollowUp ref={inputRef} handleNext={onSubmit} handleClose={handleClose} />
                }
            ];
            setLeadStep(STEPS);
        } else {
            const STEPS = [
                {
                    label: 'Contact',
                    component: <Activities activityList={activityList.results} notAllow />
                }
            ];
            setLeadStep(STEPS);
        }
    }, [contactLead]);

    useEffect(() => {
        if (BookingAttendance) {
            const steps = [...STEPS];
            steps.push({
                label: isAppointmentBooked === 'Booking Details' ? 'Booking outcome' : isAppointmentBooked === 'Unable to contact' ? 'Unable to Contact' : 'Booking outcome',
                component: isAppointmentBooked === 'Booking Details'
                    ? <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} />
                    : isAppointmentBooked === 'Unable to contact' ?
                        <UnableToContact ref={inputRef} handleNext={onSubmit} completeFlow={handleClose} />
                        : <AppointmentPage ref={inputRef} handleNext={onSubmit} />
            });
            setLeadStep(steps);
            return;
        }
        setLeadStep(STEPS);
    }, [BookingAttendance]);

    useEffect(() => {
        if (attendance && isAppointmentBooked !== 'Appointment Not Booked') {
            const steps = [...STEPS];
            if (attendance === 'attendance') {
                steps.push({
                    label: 'Booking outcome',
                    component: isAppointmentBooked === 'Booking Details'
                        ? <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} />
                        : isAppointmentBooked === 'Unable to contact' ?
                            <UnableToContact ref={inputRef} handleNext={onSubmit} completeFlow={handleClose} />
                            : <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                });
                steps.push({
                    label: 'Appointment Outcome',
                    component: <AttendedAppointment ref={inputRef} handleNext={onSubmit} isOverview />
                });
            } else {
                steps.push({
                    label: 'Booking outcome',
                    component: isAppointmentBooked === 'Booking Details'
                        ? <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} />
                        : isAppointmentBooked === 'Unable to contact' ?
                            <UnableToContact ref={inputRef} handleNext={onSubmit} completeFlow={handleClose} />
                            : <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                });
                steps.push({
                    label: 'Patient Detail',
                    component: <PersonalDetails ref={inputRef} handleNext={onSubmit} />
                });
                steps.push({
                    label: 'Payment options',
                    component: <PaymentOption ref={inputRef} handleNext={onSubmit} />
                });
                steps.push({
                    label: 'Message review & reminders',
                    component: <MessageAndReminder ref={inputRef} handleNext={onSubmit} type={'CreatLead'} />
                });
            }
            setLeadStep(steps);
        } else {
            setLeadStep(STEPS);
        }
    }, [attendance]);

    useEffect(() => {

        if (markAsComplete && followUpLead === 'contact') {
            dispatch(updateLeadDetail(isAppointmentBooked, handleClose));
        }
        if (markAsComplete && followUpLead === 'consultation') {
            dispatch(ConsultationAttended(handleClose));
        }
        if (markAsComplete && followUpLead === 'Attended') {
            dispatch(RecordAttended(handleClose));
        }
        if (markAsComplete && followUpLead === 'UnAttended') {
            dispatch(recordUnAttended(handleClose));
        }
        if (markAsComplete && followUpLead === 'archivedLead') {
            dispatch(ArchivedLeadDashBoard(handleClose));
            onCloseArchiveLead()
        }

    }, [markAsComplete, followUpLead]);

    const handleReminder = (value) => {
        dispatch(updateTaskCounter([]));
        dispatch(updateSeparateTaskCounter([]));
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        if (value === 'markComplete') {
            if (type === 'LeadDetail') {
                dispatch(updateLeadTaskCounter([]));
                dispatch(getLeadReminderData(practiceId, type, rowsPerPage, rowsPerPage * page, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', assignees, '', 'leadNotes', 'counter', additionalTabState, isTasksCompleted, false, selectedDateRange, unassignedUser, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
                dispatch(leadTaskListCounter(practiceId, 'LeadDetail', leadDetail?.lead_treatments[0]?.status, leadDetail?.id));
                dispatch(leadTaskListCounter(practiceId, 'LeadDetail', 'TODO', leadDetail?.id));
                dispatch(leadTaskListCounter(practiceId, 'LeadDetail', '', leadDetail?.id));
                dispatch(followUpSlice(leadId.id, practiceId, 'LeadDetail'));
                return;
            }
            // Re-fetch task list from offset 0 so per-lane fetch works correctly
            dispatch(getLeadReminderData(practiceId, type, rowsPerPage, 0, currentTab === 'All' ? '' : currentTab, '', assignees, '', '', '', additionalTabState, isTasksCompleted, false, selectedDateRange, unassignedUser, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
            reloadTaskCounter({ userId: assignees, id: '', additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser, treatment: taskWidgetTreatmentValue });
            // Reload dashboard widget counters so action cards update
            if (type === 'dashboard' || isDashboard) {
                reloadWidgetCounter({ array: DASHBOARD_WIDGET_COUNTER });
            }
            return;
        }
        if (type === 'LeadDetail') {
            dispatch(followUpSlice(leadId.id, practiceId, 'LeadDetail'));
            dispatch(getLeadNotes(leadId.id, practiceId, handleSuccess));
            dispatch(getLeadNotesWithFilter(leadId?.id, practiceId, handleSuccess));
            dispatch(getActivities(practiceId, leadId.id, 10, 0));
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan', '', additionalTabState, isTasksCompleted, false, selectedDateRange, unassignedUser, taskWidgetTreatmentValue));
        }
        if (type === 'dashboard') {
            dispatch(getNewLead({ id: practiceId, limit: perPage, offset: pageNumber, filterStatus: updateStatus, order, orderId: orderValue, searchQuery: search, treatment: treatment?.toString(), startDate, endDate, contactedCount: null, tags: filterTags.toString(), referral: updateStatus }));
        }
        dispatch(updateLeadTaskCounter([]));
        dispatch(getLeadReminderData(practiceId, type, rowsPerPage, rowsPerPage * page, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', assignees, '', '', 'counter', additionalTabState, isTasksCompleted, false, selectedDateRange, unassignedUser, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
        reloadTaskCounter({ userId: assignees, id: type === 'LeadDetail' ? leadId.id : '', additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser, treatment: taskWidgetTreatmentValue });
        addTableData(rowsPerPage, rowsPerPage * page, currentTab === 'All' ? '' : currentTab, assignees);
        // Reload dashboard widget counters so action cards update after follow-up/status changes
        if (type === 'dashboard' || isDashboard) {
            reloadWidgetCounter({ array: DASHBOARD_WIDGET_COUNTER });
        }
    };

    const handleSuccess = (data) => {
        if (data.message === 'Task completed !' || data.message === 'Task updated successfully !') {
            setMarkComplete(false);
            const key = enqueueSnackbar(data.message || '', {
                variant: data.success ? 'success' : 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                autoHideDuration: 5000,
                action:
                    <>
                        <Button onClick={() => undoReminder()} variant='success' size="small" sx={{ color: '#00AB55', '&:hover': { bgcolor: 'rgba(84, 214, 44, 0.16)' } }}>
                            Undo
                        </Button>
                        <Iconify onClick={() => closeSnackbar(key)} icon={'radix-icons:cross-2'} height={15} width={15} sx={{ margin: '0px 8px', cursor: 'pointer' }} />
                    </>
            });
            return;
        }
        if (data.message === 'Task not completed !') {
            setMarkComplete(false);
            enqueueSnackbar(data.message || '', {
                variant: data.success ? 'success' : 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
            });
            return;
        }
        enqueueSnackbar(data.message || '', {
            variant: data.success ? 'success' : 'error',
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
        });
    };

    const undoReminder = () => {
        setMarkComplete(false);
        const data = {
            is_completed: false
        };
        dispatch(updateReminder(data, reminderDataId.current, practiceId, handleReminder, 'markComplete'));
        closeSnackbar();
    };

    const handleDeleteReminder = (data) => {
        setDeleteData(data);
        setDeleteConfirm(true);
    };

    const deleteConfirmAPI = () => {
        dispatch(deleteReminderData(practiceId, deleteData?.id, handleSuccess, handleReminder));
        sidebarCloser();
    };

    const {
        toggle: openContacts,
        onOpen: onOpenContacts,
        onClose: onCloseContacts
    } = useToggle();

    const {
        toggle: leadDetailModal,
        onOpen: onLeadDetail,
        onClose: onCloseLeadDetail
    } = useToggle();

    const {
        toggle: openRecordAttend,
        onOpen: onOpenRecordAttend,
        onClose: onCloseRecordAttend
    } = useRecordAttendToggle();

    const {
        toggle: openUnRecordAttend,
        onOpen: onOpenUnRecordAttend,
        onClose: onCloseUnRecordAttend
    } = useUnRecordAttendToggle();

    const {
        toggle: openArchiveLead,
        onOpen: onOpenArchiveLead,
        onClose: onCloseArchiveLead
    } = useArchivedToggle();

    const {
        toggle: openReminder,
        onOpen: onOpenReminder,
        onClose: onCloseReminder
    } = useReminderToggle();

    const {
        toggle: openAssignTask,
        onClose: onCloseAssignTask
    } = useAssignTaskToggle();

    const {
        toggle: openConsultationAttend,
        onOpen: onOpenConsultationAttend,
        onClose: onCloseConsultationAttend
    } = useConsultationAttendToggle();

    const {
        toggle: openAppointmentAssignTask,
        onOpen: onOpenAppointmentAssignTask,
        onClose: onCloseAppointmentAssignTask
    } = useAssignTaskToggle();

    const openAppointmentAssignTaskFuc = (value, assignees, event) => {
        setAnchorElAssign(anchorElAssign ? null : event.currentTarget);
        onOpenAppointmentAssignTask();
        setReminderID(value?.lead_id);
        setAssignees(assignees);
    };

    const onCloseAppointmentAssignTaskPopup = () => {
        onCloseAppointmentAssignTask();
    };

    const editDetailHandler = () => {
        onLeadDetail();
    };

    const closeEditDetails = () => {
        onCloseLeadDetail();
    };

    const handlePopup = (id, reminder, status, taskData) => {
        localStorageRemoveItem('localTreatmentData');
        if (status === 'NEW') {
            dispatch(getActivities(practiceId, id, 10, 0));
        }
        dispatch(setCurrentTreatmentDataGlobal(null));
        dispatch(updateFollowUpLead('contact'));
        // HOTFIX 2026-05-13 — when invoked from the global /tasks page, the
        // reminder may not be in this component's local `reminderList` state
        // (which is hydrated lazily from `taskPageData.results`). In that
        // case `leadDataHandler` zeroes out rowLead, leaving `user.lead_id`
        // empty and the popup's treatments fetch never resolves — the right
        // panel sticks on the loading bar forever. Prefer constructing
        // rowLead from the live task object whenever the caller supplies it.
        if (taskData?.lead && taskData?.lead_treatment) {
            reminderDataId.current = taskData.id;
            setRowLead({
                ...taskData.lead,
                lead_id: taskData.lead_treatment.lead || taskData.lead.id || '',
                treatment_id: taskData.lead_treatment.id || '',
                price: taskData.lead_treatment.price || '',
                first_name: taskData.lead.first_name || '',
                last_name: taskData.lead.last_name || '',
                status: taskData.lead_treatment.status || '',
                treatment_name: taskData.lead_treatment.treatment || '',
                created_at_human: taskData.lead.created_at_human,
                lead_treatments__lead_contacted_counts__count: taskData.lead_treatment.lead_contacted_counts?.find(item => item.status === taskData.lead_treatment.status)?.count || 0,
                clinCheckData: taskData.lead_treatment.leadtreatment_clincheck,
                leadTreatmentSpecification: taskData.lead_treatment.leadtreatment_specification,
                treatmentData: taskData.lead_treatment,
                taskId: taskData.id,
            });
        } else {
            leadDataHandler(reminder);
        }
        setLead(id);
        dispatch(followUpSlice(id, practiceId));
        setTimeout(() => {
            const htmlElement = document.querySelector('body');
            htmlElement.classList.add('overflow-hidden');
            onOpenContacts();
        }, 800);
    };

    const handleWhatsappPopup = (leadData) => {
        localStorageRemoveItem('localTreatmentData');
        dispatch(initializeFacebookAuthToken());
        setOpenContactWhatsapp({ open: true });
        dispatch(getActivities(practiceId, leadData?.lead?.id, 10, 0));
        dispatch(setCurrentTreatmentDataGlobal(null));
        dispatch(updateFollowUpLead('contact'));
        setRowLead({
            ...leadData?.lead,
            lead_id: leadData?.lead?.id || '',
            treatment_id: leadData?.lead_treatment?.id || '',
            price: leadData?.lead_treatment?.price || '',
            first_name: leadData?.lead?.first_name || '',
            last_name: leadData?.lead?.last_name || '',
            status: leadData?.lead_treatment?.status || '',
            treatment_name: leadData?.lead_treatment?.treatment || '',
            created_at_human: leadData?.lead?.created_at_human,
            lead_treatments__lead_contacted_counts__count: leadData?.lead_treatment?.lead_contacted_counts?.find(item => item.status === leadData?.lead_treatment?.status)?.count || 0,
            clinCheckData: leadData?.lead_treatment?.leadtreatment_clincheck,
            leadTreatmentSpecification: leadData?.lead_treatment?.leadtreatment_specification,
            treatmentData: leadData?.lead_treatment,
            taskId: leadData?.id
        });
        setLead(leadData?.lead?.id);
        dispatch(followUpSlice(leadData?.lead?.id, practiceId));
        setTimeout(() => {
            const htmlElement = document.querySelector('body');
            htmlElement.classList.add('overflow-hidden');
            onOpenContacts();
        }, 800);
    }

    const handleAttendedPopup = async (id, reminder) => {
        localStorageRemoveItem('localTreatmentData');
        dispatch(updateFollowUpLead('consultation'));
        leadDataHandler(reminder);
        setLead(id);
        dispatch(followUpSlice(id, practiceId));
        const taskData = reminderList?.find((el) => el.id === reminder);
        dispatch(setCurrentTreatmentDataGlobal({
            lead_id: taskData?.lead?.id || id || '',
            first_name: taskData?.lead?.first_name || '',
            last_name: taskData?.lead?.last_name || '',
            treatmentData: taskData?.lead_treatment
        }));
        setTimeout(() => {
            dispatch(getAppointment(practiceId, id));
            onOpenConsultationAttend(id);
        }, 800);
    };

    const leadDataHandler = (id) => {
        reminderDataId.current = id;
        const leadData = reminderList?.filter((el) => el.id === id);
        setRowLead({
            lead_id: leadData[0]?.lead_treatment?.lead || '',
            treatment_id: leadData[0]?.lead_treatment?.id || '',
            price: leadData[0]?.lead_treatment?.price || '',
            first_name: leadData[0]?.lead?.first_name || '',
            last_name: leadData[0]?.lead?.last_name || '',
            status: leadData[0]?.lead_treatment?.status || '',
            treatment_name: leadData[0]?.lead_treatment?.treatment || '',
            created_at_human: leadData[0]?.lead?.created_at_human,
            lead_treatments__lead_contacted_counts__count: leadData[0]?.lead_treatment?.lead_contacted_counts?.find(item => item.status === leadData[0]?.lead_treatment?.status)?.count || 0,
            clinCheckData: leadData[0]?.lead_treatment?.leadtreatment_clincheck,
            leadTreatmentSpecification: leadData[0]?.lead_treatment?.leadtreatment_specification,
            treatmentData: leadData[0]
        });
    };

    useEffect(() => {
        if (rowLead) {
            dispatch(tableLead(rowLead));
        }
    }, [rowLead]);

    const switchHandler = (value) => {
        dispatch(taskUnassignedUser(false));
        dispatch(setAssigned(value));
        dispatch(getLeadReminderData(practiceId, type, 10, 0, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', value ? userID : '', '', '', '', additionalTabState, isTasksCompleted, false, selectedDateRange, false, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
        addTableData(10, 0, currentTab === 'All' ? '' : currentTab, value ? userID : '');
        onChangeRowsPerPage({ target: { value: 10 } });

        if (type === 'LeadDetail') {
            dispatch(updateLeadTaskCounter([]));
        }
        else if (type === 'dashboard') {
            dispatch(updateTaskCounter([]));
        }
        else if (type === 'Tasks') {
            dispatch(updateSeparateTaskCounter([]));
        }

        reloadTaskCounter({ userId: value ? userID : '', id: type === 'LeadDetail' ? leadId.id : '', additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser: false, treatment: taskWidgetTreatmentValue });
    };

    const switchCompletedTasksHandler = (value) => {
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';

        dispatch(taskCompletedUser(value));
        dispatch(getLeadReminderData(practiceId, type, 10, 0, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', assignees, '', '', '', additionalTabState, value, false, selectedDateRange, unassignedUser, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
        addTableData(10, 0, currentTab === 'All' ? '' : currentTab, assignees);
        onChangeRowsPerPage({ target: { value: 10 } });

        if (type === 'LeadDetail') {
            dispatch(updateLeadTaskCounter([]));
        }
        else if (type === 'dashboard') {
            dispatch(updateTaskCounter([]));
        }
        else if (type === 'Tasks') {
            dispatch(updateSeparateTaskCounter([]));
        }
        reloadTaskCounter({ userId: assignees, id: type === 'LeadDetail' ? leadId.id : '', additionalFilter: additionalTabState, CompletedTask: value, unassignedUser, treatment: taskWidgetTreatmentValue });
        if (type === 'dashboard' || isDashboard) {
            reloadWidgetCounter({ array: DASHBOARD_WIDGET_COUNTER });
        }
    };

    const switchUnassignedTasksHandler = (value) => {
        dispatch(setAssigned(false));
        dispatch(taskUnassignedUser(value));
        dispatch(getLeadReminderData(practiceId, type, 10, 0, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', '', '', '', '', additionalTabState, isTasksCompleted, false, selectedDateRange, value, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
        addTableData(10, 0, currentTab === 'All' ? '' : currentTab, '');
        onChangeRowsPerPage({ target: { value: 10 } });

        if (type === 'LeadDetail') {
            dispatch(updateLeadTaskCounter([]));
        }
        else if (type === 'dashboard') {
            dispatch(updateTaskCounter([]));
        }
        else if (type === 'Tasks') {
            dispatch(updateSeparateTaskCounter([]));
        }
        reloadTaskCounter({ userId: '', id: type === 'LeadDetail' ? leadId.id : '', additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser: value, treatment: taskWidgetTreatmentValue });
    };

    const switchHandleAllTasks = () => {
        dispatch(setAssigned(false));
        dispatch(taskUnassignedUser(false));
        dispatch(getLeadReminderData(practiceId, type, 10, 0, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', '', '', '', '', additionalTabState, isTasksCompleted, false, selectedDateRange, false, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
        addTableData(10, 0, currentTab === 'All' ? '' : currentTab, '');
        onChangeRowsPerPage({ target: { value: 10 } });

        if (type === 'LeadDetail') {
            dispatch(updateLeadTaskCounter([]));
        }
        else if (type === 'dashboard') {
            dispatch(updateTaskCounter([]));
        }
        else if (type === 'Tasks') {
            dispatch(updateSeparateTaskCounter([]));
        }
        reloadTaskCounter({ userId: '', id: type === 'LeadDetail' ? leadId.id : '', additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser: false, treatment: taskWidgetTreatmentValue });
    };

    const allPopupCloseHandler = (value) => {
        dispatch(setLoader(false));
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        switch (value) {
            case 'Reminder':
                dispatch(updateTaskCounter([]));
                dispatch(addLeadTaskTab(''));
                onCloseReminder();
                if (type === 'LeadDetail') {
                    onChangeTab('', 'All');
                    dispatch(setAssigned(false));
                    dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, '', leadId.id, assignees, '', 'leadNotes', 'counter', additionalTabState, isTasksCompleted, '', '', '', taskWidgetTreatmentValue));
                    dispatch(leadTaskListCounter(practiceId, 'LeadDetail', leadDetail?.lead_treatments[0]?.status, leadId.id, assignees, additionalTabState));
                    dispatch(leadTaskListCounter(practiceId, 'LeadDetail', 'TODO', leadId.id, assignees, additionalTabState));
                    dispatch(leadTaskListCounter(practiceId, 'LeadDetail', '', leadId.id, assignees, additionalTabState));
                    setLeadData({});
                    return;
                }
                dispatch(updateTaskCounter([]));
                dispatch(getLeadReminderData(practiceId, type, rowsPerPage, rowsPerPage * page, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', assignees, '', 'leadNotes', 'counter', additionalTabState, isTasksCompleted, false, selectedDateRange, unassignedUser, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
                reloadTaskCounter({ userId: assignees, additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser, treatment: taskWidgetTreatmentValue });
                if (type === 'dashboard' || isDashboard) {
                    reloadWidgetCounter({ array: DASHBOARD_WIDGET_COUNTER });
                }
                return;
            case 'Attended':
                onCloseRecordAttend();
                setAnchorElAssign(null);
                break;
            case 'Dialog':
                dispatch(clearLead());
                dispatch(setCurrentTreatmentDataGlobal(null));
                dispatch(updateSteps(null));
                onCloseContacts();
                setOpenSidebar(false);
                setOpenContactWhatsapp({ open: false });
                break;
            case 'UnAttended':
                onCloseUnRecordAttend();
                break;
            case 'Consultation':
                onCloseConsultationAttend();
                setAnchorElAssign(null);
                break;
            case 'Assigned':
                onCloseAssignTask();
                setAnchorElAssign(null);
                break;
            default:
                break;
        }
        dispatch(getLeadReminderData(practiceId, type, rowsPerPage, rowsPerPage * page, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', assignees, '', '', '', additionalTabState, isTasksCompleted, false, selectedDateRange, unassignedUser, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
        addTableData(rowsPerPage, rowsPerPage * page, currentTab === 'All' ? '' : currentTab, assignees);
    };

    const getReminderBtn = (status, id, reminder, leadTreatment, archive, actionType) => {
        const isWhatsapp = actionType === "WHATSAPP";
        if (archive) {
            return <Button
                variant="contained"
                color='primary'
                disabled
                sx={{ mb: '4px' }}
            >
                Archived
            </Button>;
        }
        if (isWhatsapp) {
            return <Button
                variant="contained"
                color='primary'
                startIcon={<Iconify icon={'ic:round-whatsapp'} height={20} width={20} />}
                onClick={() => handleWhatsappPopup(leadData)}
                sx={taskButtonForWhatsapp}
            >
                <Typography sx={{ fontSize: "0.8rem" }}>Whatsapp to Close Conversation</Typography>
            </Button>;
        }
        if (!leadTreatment) {
            return '';
        }
        if (status === 'CLOSED' || status === 'TREATMENT_STARTED') {
            if (type === 'LeadDetail' && status === 'CLOSED') {
                return '';
            }
            return <Button
                variant="contained"
                color='primary'
                onClick={() => viewDetailBtn(id, status, reminder)}
                sx={taskButton}
            >
                {status === 'CLOSED' ? 'View details' : 'Complete treatment'}
            </Button>;
        }
        if (status === 'CONSULTATION_ATTENDED') {
            return <Button
                variant="contained"
                color='primary'
                startIcon={<Iconify icon={'fluent:call-32-filled'} height={15} width={15} />}
                onClick={() => handleAttendedPopup(id, reminder)}
                sx={taskButton}
            >
                Follow Up
            </Button>;
        }
        if (status === 'FAILED_TO_ATTEND_CONSULTATION') {
            return <Button
                variant="contained"
                color='primary'
                startIcon={<Iconify icon={'fluent:call-32-filled'} height={15} width={15} />}
                onClick={() => handleAttendFailedClick(id, reminder)}
                sx={taskButton}
            >
                Follow Up
            </Button>;
        }
        return <Button
            variant="contained"
            color='primary'
            startIcon={<Iconify icon={'fluent:call-32-filled'} height={15} width={15} />}
            onClick={() => handlePopup(id, reminder, status)}
            sx={taskButton}
        >
            Follow Up
        </Button>;
    };

    const handleFollowUp = (status, id, reminder, leadTreatment, archive, taskData) => {
        if (archive) return;
        // HOTFIX 2026-05-13 — restore the guard that #311 removed. Without
        // it, V1 Follow Up on a reminder with null lead_treatment (common
        // on tasks-v2 practices where the V2→V1 mirror sometimes drops the
        // FK) cascades to handlePopup with undefined leadId, leadDataHandler
        // with a number-instead-of-object, and crashes the date-fns isEqual
        // chain inside OpenContactLeadPopup — whitescreening the page.
        // Pre-prod evidence: console log
        //   "[apiCall] Blocked request with invalid path parameter:
        //    /api/v1/practices/19/leads/undefined/?slim=true"
        if (!leadTreatment) return;
        const effectiveStatus = status || leadTreatment?.status || 'NEW';
        const effectiveLeadId = id || reminder?.lead?.id || reminder?.lead;
        // Belt-and-braces — if we somehow still don't have a leadId, abort.
        if (!effectiveLeadId) return;
        if (effectiveStatus === 'CLOSED' || effectiveStatus === 'TREATMENT_STARTED') {
            viewDetailBtn(effectiveLeadId, effectiveStatus, reminder);
            return;
        }
        if (effectiveStatus === 'CONSULTATION_ATTENDED') {
            handleAttendedPopup(effectiveLeadId, reminder);
            return;
        }
        if (effectiveStatus === 'FAILED_TO_ATTEND_CONSULTATION') {
            handleAttendFailedClick(effectiveLeadId, reminder);
            return;
        }
        handlePopup(effectiveLeadId, reminder, effectiveStatus, taskData);
    };

    const viewDetailBtn = (id, status, reminder) => {
        localStorageRemoveItem('localTreatmentData');
        if (status === 'CLOSED') {
            navigate(`/dashboard/practice/${practiceId}/lead-detail/${id}`);
            return;
        }
        if (status === 'TREATMENT_STARTED') {
            setConfirmation(true);
            reminderDataId.current = reminder;
        }
    };

    const completeTreatmentAPI = () => {
        const reminderId = reminderList.filter((el) => el.id === reminderDataId.current);
        const data = {
            treatment: reminderId[0]?.lead_treatment?.treatment || leadData?.lead_treatment?.treatment || '',
            custom_price: reminderId[0]?.lead_treatment?.price || leadData?.lead_treatment?.price || ''
        };
        dispatch(setLoader(true));
        dispatch(CompleteTreatment(data, reminderId[0]?.lead_treatment?.lead || leadData?.lead_treatment?.lead, reminderId[0]?.lead_treatment?.id || leadData?.lead_treatment?.id, practiceId, handleClose));
    };

    const markCompleteBtn = (value, markTasks) => {
        reminderDataId.current = value;
        setMarkComplete(value);
        const data = {
            // eslint-disable-next-line no-unneeded-ternary
            is_completed: markTasks ? false : true,
        };
        dispatch(updateReminder(data, value, practiceId, handleReminder, 'markComplete', handleSuccess, markTasks && 'isCompleted'));
    };

    const tabCounter = (data) => {
        if (type === 'LeadDetail') {
            return taskLeadCounter?.filter(value => value.filter === data ? value.count : 0)[0]?.count;
        }
        if (type === 'dashboard') {
            return taskCounter?.filter(value => value.filter === data ? value.count : 0)[0]?.count;
        }
        if (type === 'Tasks') {
            return separateTaskCounter?.filter(value => value.filter === data ? value.count : 0)[0]?.count;
        }
        return 0;
    };

    const sidebarHandler = (data) => {
        // V2 rows: delegate to the parent's onV2TaskClick handler so the V2
        // slideout opens *in place* on the consumer page (e.g. dashboard).
        // Falls back to the V1 sidebar if no handler is provided (legacy callers).
        if (data?._isV2Task && data?._v2TaskId && typeof onV2TaskClick === 'function') {
            onV2TaskClick(data._v2TaskId);
            return;
        }
        setLeadData(data);
        setOpenSidebar(true);
    };

    const sidebarCloser = () => {
        setDeleteConfirm(false);
        setOpenSidebar(false);
        // const tabQuery = tab?.length > 0 ? `?tab=${tab}` : '';
        // navigate(`${pathname}${tabQuery}`, { replace: true });
        setDeleteData(null);
        setLeadData(null);
    };

    const handleArchivedClose = () => {
        onCloseArchiveLead();
        dispatch(updateFollowUpLead('contact'));
    };

    const { toggle: openNotePopup, onClose: onCloseNotePopup } = useSwitchUserToggle();

    const handleCloseNotePopup = () => {
        onCloseNotePopup();
        setLeadData({});
    };

    const handleDropdownChange = (event) => {
        const values = event.target.value;
        setSelectedAssigneeFilter([]);
        setValue('multiSelectAssignee', []);
        if (values === 'My tasks') {
            setSelectedValue('My tasks');
            switchHandler(true);
        } else if (values === 'Unassigned tasks') {
            setSelectedValue('Unassigned tasks');
            switchUnassignedTasksHandler(true);
        } else {
            setSelectedValue('All');
            switchHandleAllTasks();
        }
    };

    const onClickAwayEvent = () => {
        const selectMenu = document.querySelector('.MuiModal-root');
        if (selectMenu) {
            return;
        }
        onCloseAssignTask();
        setAnchorElAssign(null);
        dispatch(clearPracticeUserData());
    };

    const appointmentClickAwayEvent = () => {
        const selectMenu = document.querySelector('.MuiModal-root');
        if (selectMenu) {
            return;
        }
        onCloseAppointmentAssignTaskPopup();
        setAnchorElAssign(null);
        dispatch(clearPracticeUserData());
    };

    const handleAssigneeFilter = (e, value) => {

        if (value) {
            const ids = [];
            value.forEach((data) => ids.push(data.id));
            setValue('multiSelectAssignee', ids);
            setSelectedAssigneeFilter(value);
            setSelectedValue('All');
            dispatch(setAssigned(false));
            dispatch(taskUnassignedUser(false));
            dispatch(getLeadReminderData(practiceId, type, 10, 0, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', ids?.toString() || '', '', '', '', additionalTabState, isTasksCompleted, false, selectedDateRange, unassignedUser, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
            addTableData(10, 0, currentTab === 'All' ? '' : currentTab, ids?.toString() || '');
            onChangeRowsPerPage({ target: { value: 10 } });

            if (type === 'LeadDetail') {
                dispatch(updateLeadTaskCounter([]));
            }
            else if (type === 'dashboard') {
                dispatch(updateTaskCounter([]));
            }
            else if (type === 'Tasks') {
                dispatch(updateSeparateTaskCounter([]));
            }
            reloadTaskCounter({ userId: ids?.toString(), id: type === 'LeadDetail' ? leadId.id : '', additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser, treatment: taskWidgetTreatmentValue });
        }
    }

    const handleTaskWidgetClick = (treatment) => {
        setTaskWidgetTreatmentValue(treatment)
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        dispatch(getLeadReminderData(practiceId, type, 10, 0, currentTab === 'All' ? '' : currentTab, type === 'LeadDetail' ? leadId.id : '', assignees, '', '', '', additionalTabState, isTasksCompleted, false, selectedDateRange, unassignedUser, treatment, leadStatusFilter, taskSearch));
        onChangeRowsPerPage({ target: { value: 10 } });

        if (type === 'LeadDetail') {
            dispatch(updateLeadTaskCounter([]));
        }
        else if (type === 'dashboard') {
            dispatch(updateTaskCounter([]));
        }
        else if (type === 'Tasks') {
            dispatch(updateSeparateTaskCounter([]));
        }
        reloadTaskCounter({ userId: assignees, id: type === 'LeadDetail' ? leadId.id : '', additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser, treatment });
    }

    const getChannelIcon = (method) => {
        const map = {
            CALL: 'fluent:call-12-regular',
            EMAIL: 'mdi:email-outline',
            WHATSAPP: 'mdi:whatsapp',
            SMS: 'mdi:message-text-outline',
            PAYMENT: 'mdi:credit-card-clock-outline',
        };
        return map[method] || '';
    };

    const hasMore = reminder?.count > reminderList?.length;

    const handleLoadMore = () => {
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        dispatch(loadMoreTasksPageData(practiceId, 5, reminderList?.length || 0, currentTab === 'All' ? '' : currentTab, assignees, additionalTabState, isTasksCompleted, selectedDateRange, unassignedUser, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
    };

    const handleLaneLoadMore = (laneKey, currentLaneCount) => {
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        dispatch(loadMoreTasksLaneData(practiceId, laneKey, 5, currentLaneCount, currentTab === 'All' ? '' : currentTab, assignees, isTasksCompleted, unassignedUser, taskWidgetTreatmentValue, leadStatusFilter, taskSearch));
    };

    // Parse datetime handling DD/MM/YYYY, DD-MM-YYYY, and ISO formats from API
    const parseTaskDate = useCallback((dt) => {
        if (!dt) return null;
        // Match DD/MM/YYYY HH:mm:ss or DD-MM-YYYY HH:mm:ss (with optional .0Z suffix)
        const parts = dt.match(/^(\d{2})[/-](\d{2})[/-](\d{4})[\sT]+(\d{2}):(\d{2}):(\d{2})/);
        if (parts) {
            return new Date(parts[3], parts[2] - 1, parts[1], parts[4], parts[5], parts[6]);
        }
        const d = new Date(dt);
        return Number.isNaN(d.getTime()) ? null : d;
    }, []);

    const lanes = useMemo(() => {
        const result = { doNow: [], today: [], scheduled: [] };

        if (reminderList && reminderList.length) {
            const now = new Date();
            const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            todayEnd.setDate(todayEnd.getDate() + 1);

            reminderList.reduce((acc, task) => {
                const taskDate = parseTaskDate(task.datetime);
                if (!taskDate) {
                    acc.today.push(task);
                } else if (!task.is_completed && taskDate <= now) {
                    acc.doNow.push(task);
                } else if (taskDate > now && taskDate < todayEnd) {
                    acc.today.push(task);
                } else {
                    acc.scheduled.push(task);
                }
                return acc;
            }, result);
        }

        // Inject unreplied/unread WhatsApp messages as virtual cards in Today lane
        if (threadMessages && threadMessages.length) {
            const addedWaLeadIds = new Set();
            threadMessages.forEach((contact) => {
                const leadId = contact?.lead?.id;
                const lastMsg = contact?.last_message;
                const isReceived = lastMsg?.from_waid === contact?.to_waid;
                const isUnread = !contact?.is_read && (contact?.unread_count ?? 0) > 0;
                if (leadId && lastMsg && (isReceived || isUnread) && !addedWaLeadIds.has(leadId)) {
                    addedWaLeadIds.add(leadId);
                    result.today.push({
                        _isWhatsAppVirtual: true,
                        id: `wa-${leadId}`,
                        lead: contact.lead,
                        title: lastMsg.body || '',
                        datetime_human: lastMsg.updated_at_human || '',
                        method: 'WHATSAPP',
                        unreadCount: contact?.is_read ? 0 : (contact?.unread_count ?? 0),
                        _phoneNumber: contact?.to_waid || '',
                        _thread: contact,
                    });
                }
            });
        }
        // Sort each lane by datetime.
        // WhatsApp virtual cards always pin to top of their lane so they don't slide as more reminders load.
        const sortByDateAsc = (a, b) => {
            if (a._isWhatsAppVirtual && !b._isWhatsAppVirtual) return -1;
            if (!a._isWhatsAppVirtual && b._isWhatsAppVirtual) return 1;
            const dateA = parseTaskDate(a.datetime);
            const dateB = parseTaskDate(b.datetime);
            if (!dateA && !dateB) return 0;
            if (!dateA) return 1;
            if (!dateB) return -1;
            return dateA - dateB;
        };
        const sortByDateDesc = (a, b) => {
            if (a._isWhatsAppVirtual && !b._isWhatsAppVirtual) return -1;
            if (!a._isWhatsAppVirtual && b._isWhatsAppVirtual) return 1;
            const dateA = parseTaskDate(a.datetime);
            const dateB = parseTaskDate(b.datetime);
            if (!dateA && !dateB) return 0;
            if (!dateA) return 1;
            if (!dateB) return -1;
            return dateB - dateA;
        };
        result.doNow.sort(sortByDateDesc);    // most recently overdue first
        result.today.sort(sortByDateAsc);
        result.scheduled.sort(sortByDateAsc);

        // Pin WhatsApp virtual cards (method=WHATSAPP / id starts with `wa-`)
        // to the top of the Today lane. Keeps user attention on unreplied
        // conversations before scheduled tasks.
        const isWaCard = (t) => t?.method === 'WHATSAPP' || (typeof t?.id === 'string' && t.id.startsWith('wa-'));
        const todayWa = result.today.filter(isWaCard);
        const todayRest = result.today.filter((t) => !isWaCard(t));
        result.today = [...todayWa, ...todayRest];

        return result;
    }, [reminderList, threadMessages]);

    const totalInView = reminderList?.length || 0;
    const completedInView = reminderList?.filter(t => t.is_completed)?.length || 0;

    const getContactCount = (data) => {
        const cnt = data?.lead_treatment?.lead_contacted_counts?.[0]?.count;
        return typeof cnt === 'number' ? cnt : null;
    };

    const getContactCountColor = (count) => {
        if (count === null || count === undefined || count === 0) return null;
        if (count === 1) return '#919EAB';
        if (count === 2) return '#FFAB00';
        return '#FF5630';
    };

    const getContactCountHint = (count) => {
        if (count === null || count === undefined || count === 0) return null;
        if (count === 1) return '1st follow-up';
        if (count === 2) return '2nd follow-up — try a different channel';
        return `${count}${count === 3 ? 'rd' : 'th'} follow-up — consider calling or escalating`;
    };

    const renderTaskCard = (data) => {
        const { icon, iconColor } = getIconAndColor(data.priority);
        const priorityColor = getPriorityColor(data.priority);
        const isOverdue = data.datetime && parseTaskDate(data.datetime) < new Date() && !data.is_completed;
        const initials = `${(data?.lead?.first_name || '')[0] || ''}${(data?.lead?.last_name || '')[0] || ''}`.toUpperCase();
        const channelIcon = getChannelIcon(data?.method);
        const taskStatus = data?.lead_treatment?.status || data?.group;
        const journeyDot = getJourneyDot(taskStatus);
        const journeyLabel = getJourneyLabel(taskStatus);
        const waThread = data?.lead?.id ? whatsappByLeadId[data.lead.id] : null;
        const waMsg = waThread?.isReceived ? waThread : null;
        const contactCount = getContactCount(data);
        const contactColor = getContactCountColor(contactCount);
        const contactHint = getContactCountHint(contactCount);

        return (
            <Paper
                key={data.id}
                sx={{
                    ...taskListCardStyle(data?.lead?.is_archived, data?.lead?.is_archive_pending, priorityColor, isOverdue),
                    borderLeft: contactColor ? `4px solid ${contactColor}` : 'none',
                    border: isOverdue ? `1px solid ${alpha(theme.palette.error.main, 0.2)}` : '1px solid #f0f0f0',
                    ...(contactColor && !isOverdue && { borderLeft: `4px solid ${contactColor}` }),
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        p: '14px 16px',
                        cursor: 'pointer',
                    }}
                    onClick={() => sidebarHandler(data)}
                >
                    {/* Header row: avatar + name + channel icon */}
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flex: 1 }}>
                            <Box sx={{
                                width: 32,
                                height: 32,
                                borderRadius: '50%',
                                bgcolor: alpha(theme.palette.primary.main, 0.08),
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                                fontWeight: 600,
                                color: 'primary.main',
                                flexShrink: 0
                            }}>
                                {initials}
                            </Box>
                            <Box sx={{ minWidth: 0, flex: 1 }}>
                                <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '18px' }} noWrap>
                                    {capitalizeFirstLetter(data?.lead?.first_name || '')} {capitalizeFirstLetter(data?.lead?.last_name || '')}
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', mt: '1px' }}>
                                    <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: journeyDot, flexShrink: 0 }} />
                                    <Typography sx={{ fontSize: '11px', color: 'text.disabled', lineHeight: '14px' }} noWrap>
                                        {journeyLabel}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
                            {data.priority && data.priority !== 'NORMAL' && (
                                <Iconify width={14} height={14} icon={icon} sx={{ color: iconColor }} />
                            )}
                            {channelIcon && <Iconify width={14} height={14} icon={channelIcon} sx={{ color: 'text.disabled' }} />}
                            <Tooltip title={data.id === markComplete || tasksCompletedUser ? 'Mark as incomplete' : 'Mark as complete'} placement='top'>
                                <Box
                                    onClick={(e) => { e.stopPropagation(); markCompleteBtn(data.id, tasksCompletedUser); }}
                                    sx={{
                                        width: 20, height: 20, minWidth: 20,
                                        borderRadius: '50%', cursor: 'pointer',
                                        border: (data.id === markComplete || tasksCompletedUser) ? 'none' : '2px solid #d0d0d0',
                                        bgcolor: (data.id === markComplete || tasksCompletedUser) ? '#00A76F' : 'transparent',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        transition: 'all 0.2s ease',
                                    }}
                                >
                                    {(data.id === markComplete || tasksCompletedUser) && <Iconify icon="mdi:check" width={14} sx={{ color: '#fff' }} />}
                                </Box>
                            </Tooltip>
                        </Box>
                    </Box>

                    {/* Task reason */}
                    <Typography sx={{ fontSize: '13px', color: isDentallySyncTask(data?.note) ? '#00A76F' : 'text.secondary', fontWeight: isDentallySyncTask(data?.note) ? 600 : 400, mb: contactHint && !waMsg ? 0.5 : waMsg ? 0.5 : 1.5, lineHeight: '18px' }} noWrap>
                        {isDentallySyncTask(data?.note) ? 'Sync with Dentally' : (data.title !== '' ? capitalizeFirstLetter(data?.title) : (data?.lead_treatment?.treatment || data?.note || ''))}
                    </Typography>

                    {/* Contact count hint */}
                    {contactHint && (
                        <Typography sx={{
                            fontSize: '11px',
                            color: contactColor,
                            fontWeight: 500,
                            mb: waMsg ? 0.5 : 1.5,
                            lineHeight: '14px',
                        }} noWrap>
                            {contactHint}
                        </Typography>
                    )}

                    {/* WhatsApp message preview — chat bubble style */}
                    {waMsg && waMsg.body && (
                        <Box
                            onClick={(e) => { e.stopPropagation(); setWaPopup({ open: true, lead: data.lead, thread: waMsg?._thread, phoneNumber: waMsg?._phoneNumber, taskId: data.id }); }}
                            sx={{
                                mb: 1.5,
                                bgcolor: '#ECE5DD',
                                borderRadius: '6px',
                                overflow: 'hidden',
                                cursor: 'pointer',
                                '&:hover': { opacity: 0.9 },
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, bgcolor: '#075E54', px: 1, py: 0.5 }}>
                                <Iconify icon="ic:baseline-whatsapp" width={12} height={12} sx={{ color: '#25D366' }} />
                                <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#fff', lineHeight: 1 }}>
                                    WhatsApp
                                </Typography>
                                {waMsg.unreadCount > 0 && (
                                    <Box sx={{
                                        minWidth: 14, height: 14, borderRadius: '7px', ml: 'auto',
                                        bgcolor: '#25D366', color: '#fff',
                                        fontSize: '9px', fontWeight: 700,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center', px: 0.5,
                                    }}>
                                        {waMsg.unreadCount}
                                    </Box>
                                )}
                            </Box>
                            <Box sx={{ px: 1, py: 0.75 }}>
                                <Box sx={{
                                    bgcolor: '#fff',
                                    borderRadius: '0 6px 6px 6px',
                                    px: 1, py: 0.5,
                                    boxShadow: '0 1px 1px rgba(0,0,0,0.06)',
                                }}>
                                    <Typography sx={{ fontSize: '11px', color: '#303030', lineHeight: '15px' }} noWrap>
                                        {waMsg.body}
                                    </Typography>
                                    {waMsg.time && (
                                        <Typography sx={{ fontSize: '9px', color: '#8696a0', textAlign: 'right', mt: '2px', lineHeight: 1 }}>
                                            {waMsg.time}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    )}

                    {/* Footer: last contact + overdue / due time */}
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        pt: 1,
                        borderTop: '1px solid',
                        borderColor: 'divider'
                    }}>
                        <Typography sx={{ fontSize: '11px', color: 'text.disabled' }}>
                            {data.datetime_human || ''}
                        </Typography>
                        {isOverdue && (
                            <Typography sx={{
                                fontSize: '11px',
                                fontWeight: 500,
                                color: 'error.main',
                                bgcolor: alpha(theme.palette.error.main, 0.08),
                                px: 1,
                                py: 0.25,
                                borderRadius: '4px'
                            }}>
                                Overdue
                            </Typography>
                        )}
                    </Box>
                </Box>
            </Paper>
        );
    };

    const renderWhatsAppCard = (data) => {
        const initials = `${(data?.lead?.first_name || '')[0] || ''}${(data?.lead?.last_name || '')[0] || ''}`.toUpperCase();
        const leadName = `${capitalizeFirstLetter(data?.lead?.first_name || '')} ${capitalizeFirstLetter(data?.lead?.last_name || '')}`.trim();
        return (
            <Paper
                key={data.id}
                sx={{
                    borderRadius: '8px',
                    overflow: 'hidden',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
                    transition: 'box-shadow 0.2s',
                    cursor: 'pointer',
                    '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.15)' },
                }}
                onClick={() => setWaPopup({ open: true, lead: data.lead, thread: data._thread, phoneNumber: data._phoneNumber, taskId: data.id })}
            >
                {/* WhatsApp-style teal header */}
                <Box sx={{
                    bgcolor: '#075E54',
                    px: 1.5,
                    py: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flex: 1 }}>
                        <Box sx={{
                            width: 28, height: 28, borderRadius: '50%',
                            bgcolor: 'rgba(255,255,255,0.2)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: '11px', fontWeight: 600, color: '#fff', flexShrink: 0,
                        }}>
                            {initials}
                        </Box>
                        <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#fff', lineHeight: '18px' }} noWrap>
                            {leadName}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        {data.unreadCount > 0 && (
                            <Box sx={{
                                minWidth: 18, height: 18, borderRadius: '9px',
                                bgcolor: '#25D366', color: '#fff',
                                fontSize: '10px', fontWeight: 700,
                                display: 'flex', alignItems: 'center', justifyContent: 'center', px: 0.5,
                            }}>
                                {data.unreadCount}
                            </Box>
                        )}
                        <Iconify icon="ic:baseline-whatsapp" width={18} height={18} sx={{ color: '#25D366' }} />
                    </Box>
                </Box>

                {/* Chat area with WhatsApp wallpaper tint */}
                <Box sx={{
                    bgcolor: '#ECE5DD',
                    backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'200\' height=\'200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cdefs%3E%3Cpattern id=\'p\' width=\'40\' height=\'40\' patternUnits=\'userSpaceOnUse\'%3E%3Ccircle cx=\'20\' cy=\'20\' r=\'1\' fill=\'%23d5cec3\' /%3E%3C/pattern%3E%3C/defs%3E%3Crect fill=\'url(%23p)\' width=\'200\' height=\'200\' /%3E%3C/svg%3E")',
                    px: 1.5,
                    py: 1.5,
                    minHeight: 60,
                }}>
                    {/* Incoming message bubble */}
                    <Box sx={{
                        bgcolor: '#fff',
                        borderRadius: '0 8px 8px 8px',
                        p: '8px 10px',
                        maxWidth: '92%',
                        boxShadow: '0 1px 1px rgba(0,0,0,0.06)',
                        position: 'relative',
                    }}>
                        <Typography sx={{ fontSize: '12px', color: '#303030', lineHeight: '17px', wordBreak: 'break-word',
                            display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                            {data.title}
                        </Typography>
                        <Typography sx={{ fontSize: '10px', color: '#8696a0', textAlign: 'right', mt: 0.5, lineHeight: 1 }}>
                            {data.datetime_human}
                        </Typography>
                    </Box>
                </Box>

                {/* Reply prompt bar */}
                <Box sx={{
                    bgcolor: '#F0F2F5',
                    px: 1.5,
                    py: 0.75,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderTop: '1px solid #e0e0e0',
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Iconify icon="mdi:reply" width={14} height={14} sx={{ color: '#075E54' }} />
                        <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#075E54' }}>
                            Reply needed
                        </Typography>
                    </Box>
                    <Iconify icon="mdi:chevron-right" width={16} height={16} sx={{ color: '#8696a0' }} />
                </Box>
            </Paper>
        );
    };

    const laneConfig = [
        { key: 'doNow', title: 'Do Now', color: '#dc2626', icon: 'mdi:fire', tasks: lanes.doNow },
        { key: 'today', title: 'Today', color: '#f59e0b', icon: 'mdi:clipboard-text-outline', tasks: lanes.today },
        { key: 'scheduled', title: 'Scheduled', color: '#6b7280', icon: 'mdi:calendar-outline', tasks: lanes.scheduled },
    ];

    return (
        <>
            <Card sx={taskCard(type)}>
                {/* Widget section */}
                {type !== 'dashboard' && (
                    <Box sx={{ px: 3, pt: 2, pb: 2.5 }}>
                        <TaskReportWidget onWidgetClick={handleTaskWidgetClick} />
                    </Box>
                )}

                {/* Filter toolbar */}
                <Paper
                    variant="outlined"
                    sx={{
                        mx: 3,
                        mb: 2,
                        p: 1.5,
                        borderRadius: 2,
                        borderColor: 'divider',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 1.5,
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1.5, flex: 1 }}>
                        <TextField
                            size="small"
                            placeholder="Search tasks..."
                            value={taskSearch}
                            onChange={handleTaskSearchChange}
                            sx={{ minWidth: 160, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Iconify icon="eva:search-fill" width={16} height={16} sx={{ color: 'text.disabled' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <FormControl variant="outlined" size="small" sx={{ minWidth: 150, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}>
                            <InputLabel>Task type</InputLabel>
                            <Select
                                value={currentTab}
                                onChange={(event) => handleFilterTask(event, event.target.value)}
                                label="Task type"
                            >
                                {TASK_TYPE_HEAD.map((item, index) => {
                                    const isSelected = item.value === currentTab;
                                    return (
                                        <MenuItem key={index} value={item.value}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Iconify icon={item?.icon} width={16} height={16} sx={{ mr: 1, color: isSelected ? primary.main : 'text.disabled' }} />
                                                    {item?.label}
                                                </Box>
                                                <Label sx={{ ml: 1, minWidth: '20px', color: isSelected ? primary.main : (isLight ? 'common.grey' : 'common.white'), background: isSelected ? 'rgba(0, 167, 111, 0.08)' : (isLight ? `${common.boxShadowColor}` : 'rgba(145, 158, 171, 0.16)') }}>
                                                    {tabCounter(item.value) || 0}
                                                </Label>
                                            </Box>
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" size="small" sx={{ minWidth: 160, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}>
                            <InputLabel>Lead status</InputLabel>
                            <Select
                                value={leadStatusFilter}
                                onChange={handleLeadStatusFilter}
                                label="Lead status"
                            >
                                {LEAD_STATUS_HEAD.map((item, index) => (
                                    <MenuItem key={index} value={item.value}>
                                        {item.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" size="small" sx={{ minWidth: 150, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}>
                            <InputLabel>Assignees</InputLabel>
                            <Select value={selectedValue} onChange={handleDropdownChange} label="Assignees">
                                <MenuItem value="All">All</MenuItem>
                                <MenuItem value="My tasks">My tasks</MenuItem>
                                <MenuItem value="Unassigned tasks">Unassigned tasks</MenuItem>
                            </Select>
                        </FormControl>
                        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                            <MultiAssigneesDropdown
                                name={'multiSelectAssignee'}
                                label='Assignee users'
                                sx={{ ...treatmentBoxStyle, maxWidth: "400px" }}
                                onChange={handleAssigneeFilter}
                                value={selectedAssigneeFilter}
                                type={type}
                            />
                        </FormProvider>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            bgcolor: (theme) => alpha(theme.palette.action.selected, 0.08),
                            borderRadius: '8px',
                            px: 1.5,
                            py: 0.5,
                        }}>
                            <Typography variant="body2" sx={{ fontSize: '12px', color: 'text.disabled', whiteSpace: 'nowrap' }}>Completed</Typography>
                            <Switch checked={Boolean(tasksCompletedUser)} onClick={(e) => switchCompletedTasksHandler(e.target.checked)} color="primary" size="small" />
                        </Box>
                    </Box>
                    {addTaskHide && (
                        <Button
                            variant="contained"
                            size="small"
                            onClick={() => handleReminderPopup('addTask')}
                            startIcon={<Iconify icon={'ic:baseline-plus'} width={18} height={18} />}
                            sx={{ bgcolor: '#00A76F', '&:hover': { bgcolor: '#007B55' }, whiteSpace: 'nowrap', height: '36px', textTransform: 'none', fontWeight: 600, fontSize: '13px', borderRadius: '8px', px: 2 }}
                        >
                            New Task
                        </Button>
                    )}
                </Paper>

                {/* Loading indicator */}
                {isLoadingFinish && (
                    <LinearProgress sx={{ mx: 3, borderRadius: 1 }} color="primary" />
                )}

                {/* Progress bar */}
                {totalInView > 0 && (
                    <Box sx={{ px: 3, pb: 1.5 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.75 }}>
                            <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>Progress</Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>
                                    {completedInView} of {totalInView} completed
                                </Typography>
                                <Box sx={{
                                    fontSize: '11px',
                                    fontWeight: 700,
                                    px: 1,
                                    py: 0.25,
                                    borderRadius: '10px',
                                    bgcolor: completedInView === totalInView ? '#dcfce7' : '#f1f5f9',
                                    color: completedInView === totalInView ? '#059669' : '#64748b',
                                }}>
                                    {Math.round((completedInView / totalInView) * 100)}%
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ height: 6, bgcolor: '#f1f5f9', borderRadius: 1, overflow: 'hidden' }}>
                            <Box sx={{
                                height: '100%',
                                width: `${(completedInView / totalInView) * 100}%`,
                                bgcolor: completedInView === totalInView ? '#10b981' : '#00A76F',
                                borderRadius: 1,
                                transition: 'width 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
                                position: 'relative',
                                overflow: 'hidden',
                                '&::after': completedInView > 0 && completedInView < totalInView ? {
                                    content: '""',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundImage: 'linear-gradient(45deg, rgba(255,255,255,0.2) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0.2) 75%, transparent 75%, transparent)',
                                    backgroundSize: '12px 12px',
                                    animation: 'progressStripe 0.8s linear infinite',
                                } : {},
                                '@keyframes progressStripe': {
                                    '0%': { backgroundPosition: '0 0' },
                                    '100%': { backgroundPosition: '12px 0' },
                                },
                            }} />
                        </Box>
                    </Box>
                )}

                {/* 3-column lane grid */}
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' }, gap: 3, px: 3, pb: 3 }}>
                    {laneConfig.map((lane) => (
                        <Box key={lane.key} sx={{ minWidth: 0 }}>
                            {/* Lane header */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5, pb: 1.5, borderBottom: `2px solid ${lane.color}` }}>
                                <Iconify icon={lane.icon} width={18} height={18} sx={{ color: lane.color }} />
                                <Typography sx={{ fontSize: '13px', fontWeight: 600 }}>{lane.title}</Typography>
                                <Typography sx={{
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    color: lane.color,
                                    bgcolor: `${lane.color}15`,
                                    px: 1,
                                    py: 0.25,
                                    borderRadius: '10px',
                                    lineHeight: '16px'
                                }}>
                                    {lane.tasks.length}
                                </Typography>
                            </Box>
                            {/* Lane tasks */}
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                {lane.tasks.map((data) => data._isWhatsAppVirtual ? renderWhatsAppCard(data) : renderTaskCard(data))}
                                {lane.key === 'today' && waLoading && (
                                    <Paper
                                        sx={{
                                            p: 2, borderRadius: 2,
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            bgcolor: '#f0fdf4',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                        }}
                                    >
                                        <Box sx={{
                                            width: 32, height: 32, borderRadius: '50%',
                                            bgcolor: '#25D366', display: 'flex',
                                            alignItems: 'center', justifyContent: 'center',
                                            animation: 'pulse 1.5s ease-in-out infinite',
                                            '@keyframes pulse': {
                                                '0%, 100%': { opacity: 1, transform: 'scale(1)' },
                                                '50%': { opacity: 0.6, transform: 'scale(0.92)' },
                                            },
                                        }}>
                                            <Iconify icon="mdi:whatsapp" width={18} sx={{ color: '#fff' }} />
                                        </Box>
                                        <Box>
                                            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#1a1a1a' }}>
                                                Loading WhatsApp messages...
                                            </Typography>
                                            <Typography sx={{ fontSize: '11px', color: '#999' }}>
                                                Checking for unreplied conversations
                                            </Typography>
                                        </Box>
                                    </Paper>
                                )}
                                {lane.tasks.length === 0 && !(lane.key === 'today' && waLoading) && (
                                    <Box sx={{
                                        p: 3,
                                        textAlign: 'center',
                                        color: 'text.disabled',
                                        fontSize: '13px',
                                        bgcolor: 'background.neutral',
                                        borderRadius: 2,
                                        border: '1px dashed',
                                        borderColor: 'divider'
                                    }}>
                                        {lane.key === 'doNow' ? 'All caught up!' : 'No tasks'}
                                    </Box>
                                )}
                                {/* Per-lane Load More — Today is fetched in full (high limit), so no pagination there */}
                                {type === 'Tasks' && lane.key !== 'today' && taskLaneCounts && taskLaneCounts[lane.key] > lane.tasks.length && (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', pt: 1 }}>
                                        <Button
                                            variant="text"
                                            size="small"
                                            onClick={() => handleLaneLoadMore(lane.key, lane.tasks.length)}
                                            sx={{
                                                textTransform: 'none',
                                                fontSize: '12px',
                                                fontWeight: 600,
                                                color: lane.color,
                                                '&:hover': { bgcolor: `${lane.color}10` },
                                            }}
                                        >
                                            Load more ({taskLaneCounts[lane.key] - lane.tasks.length} more)
                                        </Button>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    ))}
                </Box>

                {/* Empty state */}
                {(reminderList.length === 0 && reminder?.count !== undefined) && <Box sx={{ px: 3, pb: 2 }}><NotFound /></Box>}

                {/* Load more / Pagination (single-fetch fallback — only when not in per-lane mode) */}
                {type === 'Tasks' && !taskLaneCounts && hasMore && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', px: 3, pb: 2 }}>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={handleLoadMore}
                            sx={{
                                borderRadius: '8px',
                                textTransform: 'none',
                                fontSize: '13px',
                                fontWeight: 600,
                                color: 'text.secondary',
                                borderColor: 'divider',
                                px: 3,
                                '&:hover': { borderColor: 'text.disabled', bgcolor: 'action.hover' },
                            }}
                        >
                            Load more ({reminder?.count - reminderList?.length} remaining)
                        </Button>
                    </Box>
                )}
                {type !== 'Tasks' && (
                    <Box sx={{ px: 2 }}>
                        {reminder?.count > 10 &&
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50]}
                                component="div"
                                rowsPerPage={rowsPerPage}
                                count={reminder?.count || 0}
                                page={page}
                                onPageChange={(event, newPage) => handleChangePage(event, newPage)}
                                onRowsPerPageChange={(event) => handleChangePerPage(event)}
                                nextIconButtonProps={page === Math.ceil(reminder?.count / rowsPerPage) ? { disabled: true } : undefined}
                            />
                        }
                    </Box>
                )}
                <Popper
                    sx={{
                        zIndex: 1,
                        margin: '0px 20px !important',
                    }}
                    open={open}
                    anchorEl={anchorEl}
                    role={undefined}
                    transition
                    placement={isDesktop ? 'left-start' : 'right-start'}
                >
                    {({ TransitionProps }) => (
                        <Grow
                            {...TransitionProps}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={buttonHandleClose} >
                                    <MenuList id="split-button-menu" autoFocusItem sx={plusButton}>
                                        <MenuItem
                                            key="Attended"
                                            onClick={() => handleAttendClick()}
                                            sx={plusMenu}
                                        >
                                            <Iconify style={plusMenuIcon} width={20} height={20} icon={'akar-icons:check'} /> Attended
                                        </MenuItem>
                                        <MenuItem
                                            key="Failed to attend"
                                            onClick={() => handleAttendFailedClick()}
                                            sx={plusMenu}
                                        >
                                            <Iconify style={plusMenuIcon} width={20} height={20} icon={'ci:close-big'} /> Failed to attend
                                        </MenuItem>
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
                <AddReminderPopup
                    open={openReminder}
                    onClose={() => allPopupCloseHandler('Reminder')}
                    leadDetail={leadDetail}
                    leadData={leadData}
                    type={addPopupType}
                    page={type}
                    handleLoading={handleLoading}
                />
                {openAssignTask && (
                    <ClickAwayListener onClickAway={onClickAwayEvent}>
                        <Popper open={openAssignTask} anchorEl={anchorElAssign} transition placement="bottom" sx={{ zIndex: '999999' }}>
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper sx={{ borderRadius: 2 }}>
                                        <AssignTaskPopup
                                            open={openAssignTask}
                                            onClose={() => allPopupCloseHandler('Assigned')}
                                            leadDetail={leadDetail}
                                            reminder={reminderData}
                                            assignees={assigneeData?.filter((el) => el?.user?.first_name && !el?.user?.is_superuser)?.map((ele) => ele.id)}
                                        />
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </ClickAwayListener>
                )}
                <OpenAttendedPopup
                    open={openRecordAttend}
                    isOverview
                    headerButtons
                    onClose={() => allPopupCloseHandler('Attended')}
                    user={rowLead}
                    type={'recordAttended'}
                    inputRef={inputRef}
                    CreateLeadHeaderData={CreateLeadHeaderData}
                    OpenAssignTask={openAppointmentAssignTaskFuc}
                    editDetailHandler={editDetailHandler}
                />
                {openContacts && <OpenContactLeadPopup
                    open={openContacts}
                    headerButtons
                    onClose={() => allPopupCloseHandler('Dialog')}
                    openArchivePopup={onOpenArchiveLead}
                    user={rowLead}
                    steps={leadStep}
                    BookingAttendance={BookingAttendance}
                    type={'followup'}
                    validStep={validStep}
                    updateStep={() => setValidStep(!validStep)}
                    inputRef={inputRef}
                    CreateLeadHeaderData={CreateLeadHeaderData}
                    ContactedCount={rowLead?.lead_treatments__lead_contacted_counts__count}
                    showWhatsapp={openContactWhatsapp?.open ? {
                        windowDimension: { width, height },
                        chatScreenData: {
                            name: `${rowLead?.first_name} ${rowLead?.last_name}`,
                            phoneNumber: rowLead?.phone ?? '',
                            leadId: rowLead?.id,
                            isFromTask: true,
                            markCompleteFn: () => {
                                markCompleteBtn(rowLead?.taskId, tasksCompletedUser);
                                setReloadCounters(true);
                            }
                        },
                        setChatScreenData: () => { },
                        triggeredFromGrid: true
                    } : null}
                />}
                <OpenUnAttendedPopup
                    open={openUnRecordAttend}
                    headerButtons
                    onClose={() => allPopupCloseHandler('UnAttended')}
                    user={rowLead}
                    type={'recordUnAttended'}
                    inputRef={inputRef}
                    CreateLeadHeaderData={CreateLeadHeaderData}
                />
                {openArchiveLead && <ArchivedLeadPopUp
                    open={openArchiveLead}
                    headerButtons
                    onClose={handleArchivedClose}
                    user={leadData}
                    type={'archiveLead'}
                    inputRef={inputRef}
                    CreateLeadHeaderData={CreateLeadHeaderData}
                />}
                <OpenConsultationPopup
                    open={openConsultationAttend}
                    headerButtons
                    onClose={() => allPopupCloseHandler('Consultation')}
                    user={rowLead}
                    type={'consultationAttended'}
                    inputRef={inputRef}
                    CreateLeadHeaderData={CreateLeadHeaderData}
                    OpenAssignTask={openAppointmentAssignTaskFuc}
                    editDetailHandler={editDetailHandler}
                    selectedTreatmentData={currentTreatmentDataGlobal}
                />
                {openSidebar && <ReusableSidebar
                    type='Task'
                    getReminderBtn={getReminderBtn}
                    handleFollowUp={handleFollowUp}
                    handleSendWhatsApp={(reminderData) => setWaPopup({ open: true, lead: reminderData?.lead, phoneNumber: reminderData?.lead?.lead_contact?.phone, taskId: reminderData?.id })}
                    data={leadData}
                    open={openSidebar}
                    reminderDataId={reminderDataId}
                    handleAttendClick={handleAttendClick}
                    handleAttendFailedClick={handleAttendFailedClick}
                    onClose={sidebarCloser}
                    handleReminderPopup={handleReminderPopup}
                    deleteTask={handleDeleteReminder}
                    setReloadCounters={setReloadCounters}
                    parentType={type}
                />}
                {openAppointmentAssignTask && (
                    <ClickAwayListener onClickAway={() => appointmentClickAwayEvent()}>
                        <Popper open={openAppointmentAssignTask} anchorEl={anchorElAssign} transition placement="bottom" sx={{ zIndex: '999999' }}>
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper sx={{ borderRadius: 2 }}>
                                        <AppointmentAssignTaskPopup
                                            open={openAppointmentAssignTask}
                                            onClose={() => {
                                                onCloseAppointmentAssignTaskPopup();
                                                setAnchorElAssign(null);
                                            }}
                                            user={leadData}
                                            leadId={leadData || reminderData}
                                            type={'leadAssign'}
                                            leadDetail={leadDetail}
                                            assignees={assignees}
                                            selectedTreatmentData={currentTreatmentDataGlobal}
                                        />
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </ClickAwayListener>
                )}
                {leadDetailModal &&
                    <EditPersonalDetailsPopup
                        open={leadDetailModal}
                        handleClose={closeEditDetails}
                        selectedRow={leadData}
                        type={'editLead'}
                        inputRef={personalDetailPopupRef}
                        title='Edit Details'
                        headerButtons
                    />
                }
                {openNotePopup && (
                    <AddNotePopup
                        open={openNotePopup}
                        onClose={handleCloseNotePopup}
                        Users={leadData}
                        type={'TaskSidebar'}
                        options={options}
                        setTemplateOpen={setTemplateOpen}
                        templateOpen={templateOpen}
                    />
                )}
                {templateOpen && (
                    <LeadTemplate
                        openEmailCompose={Boolean(templateOpen)}
                        onCloseEmailCompose={() => {
                            setTemplateOpen(false);
                            setLeadData({});
                            document.body.style.overflowY = 'auto';
                        }}
                        practiceId={practiceId}
                        type={'EMAIL'}
                        leadDetail={leadData}
                    />
                )}
                <Dialog open={confirmation} onClose={() => setConfirmation(false)}>
                    <DialogTitle
                        sx={{
                            padding: '40px 40px 0px',
                            textAlign: 'center'
                        }}
                    >
                        Are you sure you want to complete the treatment ?
                    </DialogTitle>
                    <DialogActions
                        sx={{
                            padding: '40px !important',
                            justifyContent: 'center'
                        }}
                    >
                        <Button
                            sx={completeTreatmentCancel}
                            onClick={() => setConfirmation(false)}
                        >
                            Cancel
                        </Button>
                        <LoadingButton
                            type='submit'
                            variant='contained'
                            loading={isLoader}
                            loadingPosition='start'
                            onClick={() => completeTreatmentAPI()}
                            sx={{ ...yesBtnStyleForLoader(isLoader) }}
                            disabled={isLoader}
                        >
                            Yes
                        </LoadingButton>
                    </DialogActions>
                </Dialog>
                <Dialog open={deleteConfirm} onClose={() => setDeleteConfirm(false)}>
                    <DialogTitle
                        sx={{
                            padding: '40px 40px 0px',
                            textAlign: 'center'
                        }}
                    >
                        Are you sure you want to delete ?
                    </DialogTitle>
                    <DialogActions
                        sx={{
                            padding: '40px !important',
                            justifyContent: 'center'
                        }}
                    >
                        <Button
                            sx={completeTreatmentCancel}
                            onClick={() => setDeleteConfirm(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            sx={completeTreatmentConfirm}
                            onClick={() => deleteConfirmAPI()}
                        >
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
            </Card>
            {/* WhatsApp chat popup */}
            <Dialog
                open={waPopup.open}
                onClose={() => {
                    dispatch(resetWhatsappChat());
                    setWaPopup({ open: false, lead: null });
                }}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        overflow: 'hidden',
                        height: '70vh',
                        maxHeight: 700,
                        display: 'flex',
                        flexDirection: 'column',
                        transition: 'all 300ms ease',
                    }
                }}
            >
                {/* Embedded chat + booking panel */}
                <Box sx={{ flex: 1, overflow: 'hidden' }}>
                    {waPopup.open && waPopup.lead && (
                        <WaPopupChat lead={waPopup.lead} thread={waPopup.thread} phoneNumber={waPopup.phoneNumber} practiceId={practiceId} taskId={waPopup.taskId} />
                    )}
                </Box>
            </Dialog>
        </>
    );
};
TaskReminder.propTypes = {
    reminder: PropTypes.object,
    type: PropTypes.string,
    leadDetail: PropTypes.object,
    leadDetailTab: PropTypes.string,
    reloadTaskCounter: PropTypes.func,
    handleLoading: PropTypes.func,
    reset: PropTypes.bool,
    selectedDateRange: PropTypes.string,
    isDashboard: PropTypes.bool,
    shouldRunTaskEffect: PropTypes.object
};

export default TaskReminder;
